<template>
  <div class="all">
    <!-- 底部 -->
    <mall-fotter></mall-fotter>
    <!-- 顶部导航 -->
    <mall-header ref="header"></mall-header>
    <!-- 内容 -->
    <div class="content">
      <div class="content_detail">
        <!-- 标题 -->
        <div class="pageTitle ovh">
          <div class="pageTitleList f_l ovh" @click="goIndex">
            <p class="pageTitleListTable f_l">乐冰雪首页</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div>
          <div class="pageTitleList f_l ovh">
            <p class="pageTitleListTable f_l">订单支付</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="contentInfo">
          <!-- 标题 -->
          <div class="title ovh">
            <div class="f_l"></div>
            <div class="f_l">订单信息</div>
          </div>
          <!-- 取票人 -->
          <div class="ticketCollector" v-if="!payVisble">
            <div class="ticketCollector_title">取票人</div>
            <div class="ticketCollector_people ovh">
              <div class="now f_l" v-if="people.name !== ''">{{people.name}}</div>
              <div class="add f_l" @click="addPeople">新增取票人</div>
            </div>
            <div class="ticketCollector_txt m_t" v-if="people.name !== ''">姓名：{{people.name}}</div>
            <div class="ticketCollector_txt" v-if="people.name !== ''">身份证号码：{{people.idCard}}</div>
            <div class="ticketCollector_txt" v-if="people.name !== ''">联系电话：{{people.phone}}</div>
          </div>
          <!-- 订单列表 -->
          <div class="orderList ovh">
            <div class="orderImg f_l ovh">
              <img :src="src" />
            </div>
            <div class="orderInfo f_r ovh">
              <div class="order_title txt_a_l">{{goods_name}}</div>
              <div class="order_tab ovh">
                <div class="order_tab_list f_l overflow">
                  <div class="order_tab_list_det f_l">{{goods_label}}</div>
                </div>
                <div class="order_tab_num f_r">
                  X 1
                </div>
              </div>
              <div class="orderMoney txt_a_l">
                ¥<span>{{price}}</span>
              </div>
            </div>
          </div>
          <!-- 费用总计 -->
          <div class="expenses ovh" v-if="!payVisble">
            <div class="expensesDetail f_r">
              <div class="expenses_title txt_a_l">费用总计</div>
              <div class="expensesDetailList ovh">
                <div class="expensesDetailListLeft f_l">总计金额：</div>
                <div class="expensesDetailListRight f_r">￥{{allMoney}}</div>
              </div>
              <div class="expensesDetailList ovh">
                <div class="expensesDetailListLeft f_l">门票售价：</div>
                <div class="expensesDetailListRight f_r">￥{{price}}</div>
              </div>
              <div class="expensesDetailList ovh">
                <div class="expensesDetailListLeft f_l">优惠卷抵扣费用：</div>
                <div class="expensesDetailListRight f_r">￥{{discountMoney}}</div>
              </div>
              <div class="expensesDetailList ovh">
                <div class="expensesDetailListLeft f_l">退票费用（违约金）：</div>
                <div class="expensesDetailListRight f_r">￥{{price * 0.2}}</div>
              </div>
              <div class="expensesDetailList ovh">
                <div class="expensesDetailListLeft f_l">支付费用：</div>
                <div class="expensesDetailListRight f_r">￥{{lastMoney}}</div>
              </div>
              <div class="lastMoney txt_a_r">总计价格：<span>¥{{lastMoney}}</span> </div>
              <div class="btn ovh">
                <div class="f_r ovh txt_a_c" @click="placeOrder">提交订单</div>
              </div>
            </div>
          </div>
          <!-- 微信支付二维码 -->
          <div class="paymentCode" v-if="payVisble">
            <div class="paymentCode_title">请使用微信支付</div>
            <div class="id_number">{{id_number}}</div>
            <div class="paymentCode_img ovh" ref="qrCodeUrl"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 取票人弹框 -->
    <mall-addPeople v-if="addPeopleVisble" ref="addPeople" @addPeopleReturn="addPeopleReturn"></mall-addPeople>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";

  // 顶部导航
  import MallHeader from '@/components/headTop.vue';
  // 底部
  import MallFotter from '@/components/fotter.vue';
  // 底部
  import AddPeople from '@/page/addPeople.vue';

  // 调用的接口
  import { getGoodsDetail, placePayOrder, paymentStatus } from '@/request/api.js';
  import { baseUrl } from '@/request/request.js'
  // 二维码生成
  import QRCode from 'qrcodejs2'

  export default {
    name: 'orderPay',
    data () {
      return {
        goodsId: null, // 商品id
        field_id: null, // 雪票id
        currentDay: '', // 日期
        ordersn: '', // 微信支付订单id
        src: '', // 商品图片
        address: '', // 地址
        goods_name: '', // 商品名称
        goods_label: '', // 商品类别
        price: '', // 价格
        allMoney: '', // 总计价格
        discountMoney: '', // 优惠价格
        lastMoney: '', // 最后支付费用
        people: {
          name: '', // 姓名
          idCard: '', // 身份证号
          phone: '' // 手机号
        },
        time: 0, // 支付倒计时（最多30分钟）
        id_number: '', // 订单编号
        addPeopleVisble: false, // 取票人弹框
        payVisble: false // 是否支付
      }
    },

    // 引用顶部,底部,下单支付
    components:{
      'mall-header': MallHeader, // 顶部导航
      'mall-fotter': MallFotter, // 底部导航
      'mall-addPeople': AddPeople // 底部导航
    },

    mounted() {
      // 商品id
      this.goodsId = this.$route.params.id;
      // 日期价格id
      this.calendar_price_id = this.$route.params.calendar_price_id;
      // 日期
      this.currentDay = this.$route.params.currentDay;
      if(this.goodsId == undefined) {
        this.$router.go(-1);
      }
      // 获取商品详情
      this.getGoodsInfo();
    },

    computed:{
      
    },

    methods:{
      // 获取商品详情
      getGoodsInfo() {
        // 详情接口
        getGoodsDetail({
          id: this.goodsId, // 商品id
          date: this.currentDay, // 用户选中的日期
          token: localStorage.getItem('token')
        }).then(res => {
          if(res.code == 0) {
            var row = res.data;
            this.field_id = row.id; // 雪票id
            this.src = baseUrl() + row.goods_banner; // 商品图片
            this.address = row.address; // 地址
            this.goods_name = row.goods_name; // 商品名称
            this.goods_label = row.label; // 商品tab
            this.price = row.price; // 商品价格
            this.allMoney = row.price; // 总计价格
            this.discountMoney = 0; // 优惠价格
            this.lastMoney = row.price; // 最后支付费用
          }
        })
      },

      // 点击提交订单
      placeOrder() {
        if(this.people.name == '') {
          this.$message({
            showClose: true,
            message: '请新增取票人'
          });
          return;
        }
        // 参数
        var parameter = {
          id: this.field_id, // 雪票id
          calendar_price_id: this.calendar_price_id, // 日期价格id
          name: this.people.name, // 姓名
          id_number: this.people.idCard, // 身份证号
          phone: this.people.phone, // 手机号
          token: localStorage.getItem('token')
        }
        // 调用出现微信二维码
        placePayOrder(parameter).then(res => {
          if(res.code == 200) {
            this.payVisble = true; // 是否支付
            var row = res.data;
            // 二维码生成
            this.$nextTick(function () {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                  text: row.code_url, // 需要转换为二维码的内容
                  width: 100,
                  height: 100,
                  colorDark: '#000000',
                  colorLight: '#ffffff'
              })
            });
            // 订单编号
            this.id_number = row.ordersn;
            // 微信支付订单id
            this.ordersn = row.ordersn;
            var timer = setInterval(() => {
              // 查询订单支付状态
              this.getPaymentStatus(timer)
            }, 1000)
          }
        })
      },
      
      // 查询订单支付状态
      getPaymentStatus(timer) {
        setTimeout(()=>{
          // 参数
          var parameter = {
            out_trade_no: this.ordersn, // 微信支付订单id
            token: localStorage.getItem('token')
          }
          // 查询订单支付是否成功
          paymentStatus(parameter).then(res => {
            if(res.code == 200) {
              this.time++
              // 判断交易状态
              if(res.data.trade_state == 'SUCCESS') {
                // 支付成功
                this.$message({
                  type: 'success',
                  message: '支付成功'
                });
                // 停止定时器
                clearInterval(timer)
                // 返回上一页
                this.$router.go(-1);
              }else if(this.time >= 1800) {
                // 支付失败
                this.$message({
                  type: 'error',
                  message: '支付失败'
                });
                // 停止定时器
                clearInterval(timer)
                // 返回上一页
                this.$router.go(-1);
              }
            }
          })
        }, 0)
      },

      // 点击新增取票人按钮
      addPeople() {
        // 取票人弹框显示
        this.addPeopleVisble = true;
        this.$nextTick(() => {
          this.$refs.addPeople.init()
        })
      },

      // 点击弹框操作返回执行的参数
      addPeopleReturn(name, idCard, phone) {
        this.people.name = name; // 姓名
        this.people.idCard = idCard; // 身份证号
        this.people.phone = phone; // 手机号
        // 弹框隐藏
        this.addPeopleVisble = false;
      },
      
      // 点击返回首页
      goIndex() {
        this.$router.push({
          name: 'index',
          params: {}
        })
      },
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .calendar {
    width: 100%;
    background: #FAFCFF;
    margin: 31px 0 20px 0;
    padding: 29px 14px;
    box-sizing: border-box;
    border-radius: 19px 19px 0px 0px;
    cursor: pointer;
    .calendar-box {
      width: 100%;
      height: 100%;
      position: relative;
      .calendar-body {
        width: 100%;
        margin: 0 auto;
        .calendar-body-text {
          width: 100%;
          height: 30px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          color: #434444;
          font-weight: bold;
          font-size: 25px;
          margin-bottom: 17px;
          .text-title {
            margin: 0 20px;
          }
        }
      }
      table tr th{
        color: #ccc;
      }
      table tr th, table tr td {
        width: 130px;
        height: 66px;
      }
      table td {
        &.activeDay {
          background-color: #FF7702;
          border-radius: 4px;
          font-size: 22px;;
        }
        .currentMonth {
          color: #00BFFF
        }
        .data_money {
          font-size: 18px;
          color: #DF0002;
        }
        .data_mo {
          font-size: 18px;
          color: #fff;
        }
      }
      table td span{
        color: #333;
        cursor: pointer;
      }
      table td span.default{
        color: #e9e9e9;
      }
  }
  }
  .content {
    min-width: 1200px;
    padding: 50px 0 530px 0;
    .content_detail {
      width: 1200px;
      margin: 0 auto;
      // 页面标题
      &> .pageTitle {
        padding: 36px 0 20px 0;
        &> .pageTitleList {
          margin-right: 48px;
          &> .pageTitleListTable {
            color: #434444;
            font-size: 24px;
          }
          &> .pageTitleListImg {
            margin-left: 18px;
            width: 14px;
            height: 20px;
            margin-top: 7px;
          }
        }
        &> .pageTitleList:first-child > .pageTitleListTable {
          color: #0F7DFF;
          cursor: pointer;
        }
      }
      // 内容
      &> .contentInfo {
        min-width: 1200px;
        margin: 0 auto;
        // 标题
        &> .title {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          letter-spacing: 1px;
          margin-bottom: 20px;
          margin-top: 19px;
          &> div:first-child {
            width: 5px;
            height: 27px;
            background: #0F7DFF;
            border-radius: 1px;
            margin-top: 7px;
            margin-right: 11px;
          }
        }
        // 取票人
        &> .ticketCollector {
          width: 100%;
          height: 193px;
          background: #FFFFFF;
          box-shadow: 0px 0px 5px 0px rgba(168, 160, 160, 0.5);
          border-radius: 4px;
          padding: 12px 22px;
          box-sizing: border-box;
          &> .ticketCollector_title {
            text-align: left;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #434444;
            line-height: 21px;
            letter-spacing: 1px;
          }
          &> .ticketCollector_people {
            margin-top: 10px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            &> div {
              padding: 0 10px;
              border-radius: 4px;
              height: 21px;
              line-height: 21px;
              margin-right: 20px;
              color: #FFFFFF;
              cursor: pointer;
            }
            &> .now {
              background-color: #0F7DFF;
            }
            &> .add {
              background-color: #D8D8D8;
            }
            
          }
          &> .ticketCollector_txt {
            text-align: left;
            height: 35px;
            line-height: 35px;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #434444;
          }
          &> .m_t {
            margin-top: 10px;
          }
        }
        // 订单列表
        &> .orderList {
          padding: 37px 0;
          border-bottom: 1px solid #E3E4E4;
          &> .orderImg {
            width: 229px;
            height: 133px;
            border-radius: 4px;
            margin-right: 45px;
          }
          &> .orderInfo {
            width: 925px;
            &> .order_title {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #484949;
            }
            &> .order_tab {
              margin-top: 15px;
              &> .order_tab_list {
                &> .order_tab_list_det {
                  padding: 0 7px;
                  height: 20px;
                  line-height: 20px;
                  background: #EBF4FF;
                  border-radius: 4px;
                  border: 1px solid #0F7DFF;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #0F7DFF;
                  margin-right: 12px;
                }
                &> .order_tab_list_det:last-child {
                  margin-right: 0;
                }
              }
              &> .order_tab_num {
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #727273;
              }
            }
            &> .orderMoney {
              margin-top: 20px;
              font-size: 14px;
              color: #FF7702;
              font-weight: 600;
              font-family: PingFangSC-Semibold, PingFang SC;
              &> span {
                font-size: 30px;
              }
            }
          }
        }
        // 费用总计
        &> .expenses {
          &> .expensesDetail {
            width: 450px;
            margin-top: 39px;
            &> .expenses_title {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #434444;
              margin-bottom: 19px;
            }
            &> .expensesDetailList {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #727273;
              margin-bottom: 6px;
            }
            &> .lastMoney {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #434444;
              padding: 19px 0;
              &> span {
                color: #FF7702;
              }
            }
            &> .btn {
              margin-bottom: 42px;
              cursor: pointer;
              &> div {
                width: 169px;
                height: 66px;
                line-height: 66px;
                background: #FF7702;
                border-radius: 6px;
                font-size: 30px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
              }
            }
          }
        }
        // 微信支付二维码
        &> .paymentCode {
          margin-top: 27px;
          &> .paymentCode_title {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #434444;
            margin-bottom: 10px;
          }
          &.id_number {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999;
            margin-bottom: 12px;
          }
          &> .paymentCode_img {
            width: 223px;
            height: 223px;
            background: #D8D8D8;
            border-radius: 4px;
            margin: 0 auto;
            margin-bottom: 118px;
          }
        }
      }
    }
  }
  .font {
    font-size: 22px;
  }
  .m_19 {
    margin-top: 19px;
  }
  .el-carousel__item.is-active {
    z-index: 0;
  }
  .col_1 {
    color: #0F7DFF !important;
  }
</style>
<style scoped lang="">

  /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: #fff;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #FE951E;
    background: #FE951E;
  }

  /deep/ .el-radio__label {
    font-size: 16px !important;
    letter-spacing: 1px;
    color: #fff;
  }

  /deep/ .el-calendar-table .el-calendar-day {
    padding: 2px;
  }

  /deep/ .el-calendar-table .el-calendar-day {
    height: 66px;
  }

  /deep/ .inputNum > input:focus{border: 1px solid #DCDFE6 !important;}

  /deep/ .inputNum > input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /deep/ .inputNum > input[type="number"]{
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/page/orderPay.vue